module.exports = __webpack_public_path__ + "img/V.10ee1cc5.svg";